
const lastUpdate = '2026-06-01';
export const helpTitle = 'Weather Station Explorer';

export const helpContent = `
<h1>${helpTitle}</h1>

<h2>Overview</h2>
<p>The Weather Station Explorer shows all weather stations in the network. Browse, filter, and access station data and tools from a single grid view.</p>

<h2>Browsing Stations</h2>
<ul>
  <li>Stations are displayed in a grid — click any station to open its detail panel.</li>
  <li>The detail panel shows windroses, status charts, and recent observations.</li>
  <li>Use the <strong>Filter</strong> controls to narrow by region, status, or CFFDRS mode.</li>
</ul>

<h2>Station Toolbar</h2>
<p>Each station row includes action buttons:</p>
<ul>
  <li><strong>Map</strong> — Zooms the map to the station location.</li>
  <li><strong>Data</strong> — Opens the Weather Data Explorer pre-filtered to this station.</li>
  <li><strong>CFFDRS</strong> — Launches the CFFDRS Startup Wizard for this station.</li>
  <li><strong>Edit</strong> — Opens the station edit form (authorized users only).</li>
  <li><strong>Stats</strong> — Opens the statistics view for this station.</li>
</ul>

<h2>Sorting</h2>
<p>Click any column header to sort. Most columns sort the way you'd expect — alphabetically for text, numerically for elevation.</p>
<ul>
  <li><strong>Coordinates</strong> sorts by <strong>latitude</strong> only (the first value in the displayed "lat, lon" pair). Descending puts the northernmost stations first; ascending puts the southernmost first. Longitude is not part of the sort.</li>
</ul>

<h2>Admin Tools</h2>
<p>The <strong>Admin</strong> button (visible to administrators) provides chain maintenance tools for managing station configurations and data quality.</p>

<h2>Live Weather Map Markers</h2>
<p>Marker icon colour is driven by <strong>relative humidity only</strong>:</p>
<ul>
  <li><strong>Blue</strong> — RH &ge; 70% (humid)</li>
  <li><strong>Green</strong> — 51% &le; RH &lt; 70% (moderate)</li>
  <li><strong>Yellow</strong> — 31% &le; RH &lt; 51% (dry)</li>
  <li><strong>Orange</strong> — RH &lt; 31% (very dry)</li>
</ul>
<p>The wind barb shows direction (shaft) and speed (barbs): each full barb is 10 km/h, each half barb is 5 km/h.</p>

<h2>Live Weather Hover Card</h2>
<p>The card's <strong>temp bar</strong> and <strong>RH bar</strong> use a different palette that also considers crossover.</p>
<p><em>Temperature bar:</em></p>
<ul>
  <li><strong>Red</strong> — Crossover (Temp &ge; RH)</li>
  <li><strong>Orange</strong> — Temp &gt; 25 &deg;C</li>
  <li><strong>Cyan</strong> — 15 &lt; Temp &le; 25 &deg;C</li>
  <li><strong>Blue</strong> — Temp &le; 15 &deg;C</li>
</ul>
<p><em>RH bar:</em></p>
<ul>
  <li><strong>Red</strong> — Crossover (Temp &ge; RH)</li>
  <li><strong>Orange</strong> — RH &lt; 25%</li>
  <li><strong>Cyan</strong> — 25% &le; RH &le; 75%</li>
  <li><strong>Blue</strong> — RH &gt; 75%</li>
</ul>
<p>Grey on either bar means the value was not reported.</p>

<div class="last-update">Last Updated: ${lastUpdate}</div>
`;

export default helpContent;
